import * as Icons from "lucide-react";
import { Link } from "react-router-dom";

export default function CategoryTile({ category }) {
  const Icon = Icons[category.icon] || Icons.Sparkle;
  return (
    <Link
      to={`/recherche?category=${category.slug}`}
      data-testid={`category-tile-${category.slug}`}
      className="card-surface card-hover p-5 flex flex-col items-start gap-3 group"
    >
      <div className="w-11 h-11 rounded-xl bg-secondary flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors">
        <Icon className="w-5 h-5" />
      </div>
      <span className="font-display font-medium text-sm text-foreground leading-tight">{category.name}</span>
    </Link>
  );
}
